import { Avatar, Badge, MenuItem, Stack, Typography } from "@mui/material";
import { formatDistanceToNow } from "date-fns";

import { GqlNotification } from "~/__generated__";

import gaiaLogo from "../../../../../assets/images/gaiaLogo.png";

interface NotificationItemProps {
    notification: Pick<GqlNotification, "title" | "body" | "isRead" | "createdAt"> & {
        sender?: Pick<
            NonNullable<GqlNotification["sender"]>,
            "id" | "firstName" | "lastName" | "profilePictureMedia"
        > | null;
    };
}

export default function NotificationItem({ notification }: NotificationItemProps) {
    return (
        <MenuItem
            sx={theme => ({
                background: theme.palette.background.paper,
                padding: "12px 16px",
                justifyContent: "space-between",
                alignItems: "flex-start",
            })}
        >
            <Stack direction="row" columnGap={1} alignItems="flex-start">
                <Avatar src={notification?.sender?.profilePictureMedia?.url || gaiaLogo}>
                    {notification?.sender?.firstName[0]}
                    {notification?.sender?.lastName[0]}
                </Avatar>

                <Stack direction="column" paddingRight="16px" rowGap={0}>
                    <Typography variant="body2">
                        <b>{notification.title}</b>
                        <Typography variant="caption" marginLeft="8px" color="textDisabled">
                            {formatDistanceToNow(notification.createdAt)}
                        </Typography>
                    </Typography>
                    <Typography variant="caption" sx={{ textWrap: "wrap", wordBreak: "break-word" }}>
                        {notification.body}
                    </Typography>
                </Stack>
            </Stack>
            {!notification.isRead && <Badge color="primary" variant="dot" sx={{ marginTop: "8px" }} />}
        </MenuItem>
    );
}
